// NX progress bar (shadcn Progress restyled): 6 px pill track with a blue fill and an optional animated striped variant.
import { Progress as ProgressPrimitive } from "radix-ui";
import type * as React from "react";

import { cn } from "@/lib/cn";

type ProgressProps = React.ComponentProps<typeof ProgressPrimitive.Root> & {
  striped?: boolean;
  indicatorClassName?: string;
};

function Progress({ className, value, striped = false, indicatorClassName, ...props }: ProgressProps) {
  const fraction =
    value === null || value === undefined ? (striped ? 100 : 0) : Math.min(100, Math.max(0, value));
  return (
    <ProgressPrimitive.Root
      data-slot="progress"
      value={value}
      className={cn("relative h-1.5 w-full overflow-hidden rounded-pill bg-track", className)}
      {...props}
    >
      <ProgressPrimitive.Indicator
        data-slot="progress-indicator"
        className={cn(
          "h-full rounded-[inherit] bg-brand-blue-solid transition-[width] duration-200 ease-nx dark:bg-brand-blue",
          striped && "animate-stripes progress-stripes",
          indicatorClassName,
        )}
        style={{ width: `${fraction}%` }}
      />
    </ProgressPrimitive.Root>
  );
}

export { Progress };
